import not_found_image from "/404.jpg";
import { useNavigate } from "react-router-dom";
import { FaArrowLeft, FaHome } from "react-icons/fa";

const PageNotFound = () => {
  const nav = useNavigate();

  const handleBack = () => {
    if (window.history.length > 1) {
      nav(-1);
    } else {
      nav("/", { replace: true });
    }
  };

  return (
    <section className="flex min-h-[90vh] items-center justify-center bg-linear-to-br px-4">
      <div className="text-center">
        {/* Animated 404 Illustration */}
        <div className="relative mx-auto max-w-sm">
          <img
            src={not_found_image}
            alt="Page not found"
            className="animate-float w-full"
          />
          {/* Decorative circles */}
          <div className="absolute -top-4 -right-4 h-20 w-20 rounded-full bg-blue-200/50 blur-2xl" />
          <div className="absolute -bottom-4 -left-4 h-20 w-20 rounded-full bg-purple-200/50 blur-2xl" />
        </div>

        {/* <h1 className=" text-4xl font-extrabold tracking-tight text-gray-800 sm:text-5xl">
          404
        </h1> */}
        <h2 className="mt-2 text-2xl font-semibold text-gray-700 sm:text-3xl">
          Page Not Found
        </h2>
        <p className="mt-4 max-w-md text-gray-500">
          Oops! The page you're looking for doesn't exist or has been moved.
        </p>

        <div className="mt-8 flex flex-col items-center gap-4 sm:flex-row sm:justify-center">
          <button
            onClick={handleBack}
            className="inline-flex items-center gap-2 rounded bg-blue-500 px-6 py-3 font-medium text-white shadow-md transition-all hover:scale-105 hover:bg-blue-600 hover:shadow-lg focus:ring-2 focus:ring-blue-400 focus:ring-offset-2 focus:outline-none active:scale-95"
          >
            <FaArrowLeft size={16} />
            Go Back
          </button>
          <button
            onClick={() => nav("/")}
            className="inline-flex items-center gap-2 rounded border-2 border-gray-200 bg-white px-6 py-3 font-medium text-gray-700 shadow-sm transition-all hover:scale-105 hover:border-blue-300 hover:bg-blue-50 hover:text-blue-600 focus:ring-2 focus:ring-blue-400 focus:ring-offset-2 focus:outline-none active:scale-95"
          >
            <FaHome size={16} />
            Home
          </button>
        </div>
      </div>

      {/* Inline animation styles */}
      <style>{`
        @keyframes float {
          0% { transform: translateY(0px); }
          50% { transform: translateY(-10px); }
          100% { transform: translateY(0px); }
        }
        .animate-float {
          animation: float 4s ease-in-out infinite;
        }
      `}</style>
    </section>
  );
};

export default PageNotFound;
